import MutateDocument from "./MutateDocument";

export default MutateDocument